const getters = {
  evaluacionEnCurso: (state: any) => state.evaluacionActiva && !!state.reviewsAnswerId,
  totalPreguntas: (state: any) => state.preguntas.length
}

export default getters
